import React from 'react'
import Appbar from 'components/Appbar'
import { PageContent, ModalLayer } from '@ui'
import { Router, RouteComponentProps } from '@reach/router'
import Tableview from './Tableview'
import useBookings from './hooks/useBookings'
import { navigateWithBasepath } from '../../App'

export default function AssetManagement({ navigate }: RouteComponentProps) {
  const hook = useBookings()
  return (
    <>
      {/* eslint-disable @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Router primary={false} navigate={navigateWithBasepath}>
        <ModalLayer path="*" /*reload={}*/ />
      </Router>
      <Appbar title="Bookings">{/* search here */}</Appbar>
      <PageContent>
        <Tableview bookings={hook} navigate={navigate} />
      </PageContent>
    </>
  )
}
